import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DValorDominio } from '@dian/api-basicos-parametricas';
import { MessageObservableService } from '../../../../services/message-observable.service';
import { IngresosRetiroAFCOTROSModalComponent } from '../modales/ingresos/ingresos-modal-retiro-AFC-OTROS/ingresos-retiro-modal-AFC-OTROS.component';
import { IngresosArrendamientosModalComponent } from '../modales/ingresos/ingresos-arrendamientos/ingresos-arrendamientos-modal.component';
import { DialogoConfirmacionComponent } from '../../../table-items/dialogo-confirmacion/dialogo-confirmacion.component';
import { IngresoHerenciaDonaConyugalModalComponent } from '../modales/ingresos/ingresos-herencia-donacion-conyugal-modal/ingresos-herencia-dona-conyugal-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../modales/ingresos/ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../modales/ingresos/ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { IngresosComercianteModalComponent } from '../modales/ingresos/ingresos-comerciante/ingresos-comerciante-modal.component';
import { IngresosOtrosIngresosModalComponent } from '../modales/ingresos/ingresos-otros-ingresos-modal/ingresos-otros-ingresos-modal.component';
import { IngresosVentaViviendaModalComponent } from '../modales/ingresos/ingresos-venta-vivienda-modal/ingresos-venta-vivienda-modal.component';
import { IngresosPensionesModalComponent } from '../modales/ingresos/ingresos-pensiones/ingresos-pensiones-modal.component';
import { IngresosDividendosOParticipacionesModalComponent } from '../modales/ingresos/ingresos-dividendos-participaciones-modal/ingresos-dividendos-participaciones-modal.component';
import { IngresosUtilidadesLiquidacionModal } from '../modales/ingresos/ingresos-utilidades-liquidacion-modal/ingresos-utilidades-liquidacion-modal.component';
import { IngresosVentaActivosFijosModalComponent } from '../modales/ingresos/ingresos-venta-activos-fijos-modal/ingresos-venta-activos-fijos-modal.component';
import { IngresosRentasPasivasECEModalComponent } from '../modales/ingresos/ingresos-rentas-pasivas-ECE-modal/ingresos-rentas-pasivas-ECE-modal.component';
import { IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent } from '../modales/ingresos/ingresos-loterias-premios-rifas-apuestas-similares-modal/ingresos-loterias-premios-rifas-apuestas-similares-modal.component';
import { ComponentFactoryService } from '../../../../services/component-factory.service';
import { BeneficiosIngresosNoGravados } from '../modales/beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { BeneficiosTributariosDeduccionesEspecialesModalComponent } from '../modales/beneficios-tributarios/beneficios-tributarios-deducciones-especiales/beneficios-tributarios-deducciones-especiales-modal.component';
import { BeneficiosRentasExentasDeImpuestoModalComponent } from '../modales/beneficios-tributarios/beneficios-rentas-exentas-de-impuesto/beneficios-rentas-exentas-de-impuesto-modal.component';
import { AnticiposComponent } from '../modales/impuesto-renta/anticipos-modal/anticipos-modal.component';
import { BeneficiosTributariosDescuentosModalComponent } from '../modales/beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';


const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions: Question[] = [
  //0 I1 I1 ¿Fue asalariado o funcionario público?
  { question: '¿Fue asalariado o funcionario público?', 
    field: 'cs_id_276', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_280" },
  //1 I2 ¿Fue trabajador independiente ?
  { question: '¿Fue trabajador independiente?', 
    field: 'cs_id_301', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_305" },
  //2 I3 ¿Tuvo ingresos por arrendamientos, rendimientos financieros, intereses, regalías o explotación de propiedad intelectual en Colombia o en el exterior?
  { question: '¿Tuvo ingresos por arrendamientos, rendimientos financieros, intereses, regalías o explotación de propiedad intelectual en Colombia o en el exterior?', 
    field: 'cs_id_323', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_328" },
  //3 I4 ¿Fue comerciante, ganadero, agricultor, ejerció como notario, curador urbano o tuvo otras actividades por delegación del Estado?
  { question: '¿Fue comerciante, ganadero, agricultor, ejerció como notario, curador urbano o tuvo otras actividades por delegación del Estado? ', 
    field: 'cs_id_338', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_343" },
  //4 I5 ¿Recibió ingresos por pensión, indemnización sustitutiva de pensión o devolución de ahorro pensional?
  { question: '¿Recibió ingresos por pensión, indemnización sustitutiva de pensión o devolución de ahorro pensional?', 
    field: 'cs_id_350', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_355" 
  },
  //5 I6 ¿Retiró ahorros de cuentas AFC, FVP o AVC, sin cumplir las condiciones de permanencia y destinación?
  { question: '¿Retiró ahorros de cuentas AFC, FVP o AVC, sin cumplir las condiciones de permanencia y destinación?', 
    field: 'cs_id_367', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_372" 
  },
  //6 I7 ¿Tuvo ingresos por dividendos o participaciones?
  { question: '¿Tuvo ingresos por dividendos o participaciones?',
    field: 'cs_id_381', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_494" 
  },
  //7 I8 ¿Vendió el inmueble donde usted vivía? 
  { question: '¿Vendió el inmueble donde usted vivía?', 
    field: 'cs_id_507', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_509" 
  },
  //8 I9 ¿Vendió otros activos fijos?
  { question: '¿Vendió otros activos fijos?', 
    field: 'cs_id_534', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_539" 
  },
  //9 I10 ¿Tuvo utilidades por liquidación de alguna sociedad de la que fue socio o partícipe?
  { question: '¿Tuvo utilidades por liquidación de alguna sociedad de la que fue socio o partícipe?', 
    field: 'cs_id_564', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_568" 
  },
  //10 I11 ¿Recibió ingresos por herencias, donaciones, divorcio o porción conyugal?
  { question: '¿Recibió ingresos por herencias, donaciones, divorcio o porción conyugal?', 
    field: 'cs_id_581', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_586" 
  },
  //11 I12 ¿Recibió ingresos por loterías, premios, rifas, apuestas o similares?
  { question: '¿Recibió ingresos por loterías, premios, rifas, apuestas o similares?', 
    field: 'cs_id_604', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "1", totalField: "cs_id_608" 
  },
  //12 I13 621	I13	¿Tuvo ingresos por rentas pasivas de Entidades Controladas del Exterior (ECE)? 	NO	Ayuda Pregunta 13, se actualizará una vez esté revisada por el área funcional.
  { question: '¿Tuvo ingresos por rentas pasivas de Entidades Controladas del Exterior (ECE)?', 
    field: 'cs_id_621', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_626" 
  },
  //13 I14 ¿Tuvo otros ingresos?
  { question: '¿Tuvo otros ingresos?', 
    field: 'cs_id_635', show: true, nextIfValue: "0", isCompleted: false, resp: "", hasSuggested: "0", totalField: "cs_id_648" 
  },
];

@Component({
  selector: 'app-mis-ingresos',
  templateUrl: './mis-ingresos.component.html',
  styleUrls: ['./mis-ingresos.component.css'],
  providers: [ComponentFactoryService]

})
export class MisIngresosComponent extends HandlerComponent implements OnInit {

  @Input('listTiposDocumentos') tiposDocumentofiltrado: DValorDominio[] = [];
  @Input('listTiposParentesco') tiposParentesco: DValorDominio[] = [];
  @Input('listTipRentaAFC') tiposRentaAFC: DValorDominio[] = [];
  @Input('listConceptosIng') listaConceptosIng: DValorDominio[] = [];
  @Input('listActiIng') listaActiIng: DValorDominio[] = [];
  @Input('listaTipoPension') listaTipoPension: DValorDominio[] = [];
  @Input('model') model: DDocumento = new DDocumento();
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();
  @Input('tablaArt73') tablaArt73: any;
  @Input('valorUVT') valorUVT: any;
  @Input('listaConcepIngresoGO') listaConcepIngresoGO: any;
  @Input('listaIngGOHerencia') listaIngGOHerencia: any;
  @Input('uvt') uvt: string;  
  @Input('lisTipRentaPasivaECE') lisTipRentaPasivaECE: any; 
  @Input('listaAnioConstLiq') listaAnioConstLiq: any;
  @Input('listaTipoRenta') listaTipoRenta: DValorDominio[] = [];
  @Input('parametroPoliticaAFC') parametroPoliticaAFC: any;

  constructor(
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _componentFactory: ComponentFactoryService,
    private _messagesObs: MessageObservableService

  ) {
    super(questions);
  }


  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.initializeSiTieneSugerida();
  }

  validateQuestions(id: number) {
    console.log(id);
  }

  questionHasSugerida(index: number) {
    return questions[index].hasSuggested == "1";
  }
  /**
   * Inicializa las respuestas en Sí si la sección tiene sugerida
   */
  initializeSiTieneSugerida(){
    for (let numPregunta = 0; numPregunta < questions.length; numPregunta++) {
      if (this.questionHasSugerida(numPregunta) && questions[numPregunta].resp!="0") {
        questions[numPregunta].resp='1';
        this.model.doc.cuerpo[questions[numPregunta].field]="1";
      }
    }
  }
  
  initilizeQuestionsDesdeModelo(model) {
    for (let i = 0; i < questions.length; i++) {
      questions[i].resp = model.doc.cuerpo[questions[i].field];
      questions[i].isCompleted = this.validateModalCompleted(i);
      if (questions[i].isCompleted || model.doc.cuerpo[questions[i].field] == "1") { questions[i].show = true; }
      this.checkNextQuestion(i);
    }
  }

  private calcular702() {
    const componentBenRentasExentasImp = this._componentFactory.createModalComponent(BeneficiosRentasExentasDeImpuestoModalComponent, { model: this.model });
    componentBenRentasExentasImp.instance.uvt = this.uvt;
    componentBenRentasExentasImp.instance.inicializeModelo();
    componentBenRentasExentasImp.instance.inicializeForm();
    componentBenRentasExentasImp.instance.obtenerEliminarDataTrabInd();                    
    componentBenRentasExentasImp.instance.initializeTablaDesdeModelo();
    componentBenRentasExentasImp.instance.actualizarDataTrabajadorAsal_Indep();
    componentBenRentasExentasImp.instance.guardar();
    /* if (save) {
      componentBenRentasExentasImp.instance.guardar();
      this.saveModel.emit(true); save: boolean = false
    } */
  }

  openModal(indexQuestionModal: number) {
    const configSinSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    const configSugerida = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: {
        model: this.model
      }
    }
    let config;
    if(this.questionHasSugerida(indexQuestionModal)){
      config = configSugerida;
    }else{
      config = configSinSugerida;
    }
    switch (indexQuestionModal) {
      case 0:  //0 I1 ¿Fue asalariado o funcionario público?      
        this.calcular702();
        let dialog0: MatDialogRef<IngresosAsalariadooServidorpublicoModalComponent> = this.dialog.open(IngresosAsalariadooServidorpublicoModalComponent, config);
        dialog0.componentInstance.UVT = this.uvt;
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal); 
          this.saveModel.emit(true);
        });
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 1:  //1 I2 ¿Fue trabajador independiente ?
        let dialog1: MatDialogRef<IngresostrabajadorindependienteModalComponent> = this.dialog.open(IngresostrabajadorindependienteModalComponent, config);
        dialog1.componentInstance.UVT = this.uvt;
        dialog1.componentInstance.listaTipoRenta = this.tiposRentaAFC;
        dialog1.componentInstance.UVT = this.uvt;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.calcular702();
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 2:  //3 I3 ¿Tuvo ingresos por arrendamientos, rendimientos financieros, intereses, regalías o explotación de propiedad intelectual en Colombia o en el exterior?
        let dialog2: MatDialogRef<IngresosArrendamientosModalComponent> = this.dialog.open(IngresosArrendamientosModalComponent, config);
        dialog2.componentInstance.listaConceptosIng = this.listaConceptosIng;
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 3:  //4 I4 ¿Fue comerciante, ganadero, agricultor, ejerció como notario, curador urbano o tuvo otras actividades por delegación del Estado?
        let dialog3: MatDialogRef<IngresosComercianteModalComponent> = this.dialog.open(IngresosComercianteModalComponent, config);
        dialog3.componentInstance.listaActiIng = this.listaActiIng;
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 4:  //10 I5 ¿Recibió ingresos por pensión, indemnización sustitutiva de pensión o devolución de ahorro pensional?
        let dialog4: MatDialogRef<IngresosPensionesModalComponent> = this.dialog.open(IngresosPensionesModalComponent, config);
        dialog4.componentInstance.listaTipoPension = this.listaTipoPension;
        dialog4.componentInstance.uvt = this.uvt;
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.calcular702();
          this.saveModel.emit(true);
        });
        dialog4.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 5:  //2 I6 ¿Retiró ahorros de cuentas AFC, FVP o AVC, sin cumplir las condiciones de permanencia y destinación?
        let dialog5: MatDialogRef<IngresosRetiroAFCOTROSModalComponent> = this.dialog.open(IngresosRetiroAFCOTROSModalComponent, config);
        dialog5.componentInstance.parametroTipoRenta = this.parametroPoliticaAFC;
        dialog5.componentInstance.tiposRentaAFC = this.tiposRentaAFC;
        dialog5.componentInstance.listaTipoRenta = this.tiposRentaAFC;
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
      break;

      case 6:  //11 I7 ¿Tuvo ingresos por dividendos o participaciones?
        let dialog6: MatDialogRef<IngresosDividendosOParticipacionesModalComponent> = this.dialog.open(IngresosDividendosOParticipacionesModalComponent, config);
        dialog6.componentInstance.tablaArt73 = this.tablaArt73;
        dialog6.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog6.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 7:  //5 I8 ¿Vendió el inmueble donde usted vivía? 
        let dialog7: MatDialogRef<IngresosVentaViviendaModalComponent> = this.dialog.open(IngresosVentaViviendaModalComponent, config);
        dialog7.componentInstance.tablaArt73 = this.tablaArt73;
        dialog7.componentInstance.valorUVT = this.valorUVT;
        dialog7.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog7.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 8:  //6 I9 ¿Vendió otros activos fijos?
        let dialog8: MatDialogRef<IngresosVentaActivosFijosModalComponent> = this.dialog.open(IngresosVentaActivosFijosModalComponent, config);
        dialog8.componentInstance.tablaArt73 = this.tablaArt73;
        dialog8.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog8.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 9:  //8 I10 ¿Tuvo utilidades por liquidación de alguna sociedad de la que fue socio o partícipe?
        let dialog9: MatDialogRef<IngresosUtilidadesLiquidacionModal> = this.dialog.open(IngresosUtilidadesLiquidacionModal, config);
        dialog9.componentInstance.listaAnioConstLiq = this.listaAnioConstLiq;
        dialog9.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog9.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 10:  //12 I11 ¿Recibió ingresos por herencias, donaciones, divorcio o porción conyugal?
        let dialog10: MatDialogRef<IngresoHerenciaDonaConyugalModalComponent> = this.dialog.open(IngresoHerenciaDonaConyugalModalComponent, config);
        dialog10.componentInstance.uvt = this.uvt;
        dialog10.componentInstance.listaConcepIngresoGO = this.listaConcepIngresoGO;
        dialog10.componentInstance.listaIngGOHerencia = this.listaIngGOHerencia;
        dialog10.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog10.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 11:  //13 I12 ¿Recibió ingresos por loterías, premios, rifas, apuestas o similares?
        let dialog11: MatDialogRef<IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent> = this.dialog.open(IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent, config);
        dialog11.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog11.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 12:  //7 I13 621	I13	¿Tuvo ingresos por rentas pasivas de Entidades Controladas del Exterior (ECE)? 	NO	Ayuda Pregunta 13, se actualizará una vez esté revisada por el área funcional.
        let dialog12: MatDialogRef<IngresosRentasPasivasECEModalComponent> = this.dialog.open(IngresosRentasPasivasECEModalComponent, config);
        dialog12.componentInstance.lisTipRentaPasivaECE = this.listaTipoRenta;
        dialog12.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog12.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
      case 13:  //14 I14 ¿Tuvo otros ingresos?
        let dialog13: MatDialogRef<IngresosOtrosIngresosModalComponent> = this.dialog.open(IngresosOtrosIngresosModalComponent, config);
        dialog13.componentInstance.saveModel.subscribe(() => {
          this.dependenciadeTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog13.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        })
        break;
    }
    
    
  }

  //cs_id_276
  //cs_id_301
  //cs_id_367
  //cs_id_323
  //cs_id_338
  //cs_id_507
  //cs_id_534
  //cs_id_407
  //cs_id_564
  //cs_id_278
  //cs_id_350
  //cs_id_381
  //cs_id_581
  //cs_id_604
  //cs_id_713
  protected validateModalCompleted(indexQuestion: number): boolean {
    let isModalComplete: boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if ((this.model.doc.cuerpo[questions[indexQuestion].field] != undefined && this.model.doc.cuerpo[questions[indexQuestion].field] == "0") ||
          this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      isModalComplete = true;
    }
    if(indexQuestion==1){//1 I2 ¿Fue trabajador independiente ?
      if(this.model.doc.cuerpo['cc_id_309'] && this.model.doc.cuerpo['cc_id_309'].length>0){
        isModalComplete = true;
      }
    }
    if (isModalComplete) {
      questions[indexQuestion].isCompleted = true;
      if (questions.length > indexQuestion + 1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    } else {
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }

  public validateComponentCompleted(): boolean {
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].isCompleted == false) {
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }
  
  protected validateHasModalValues(indexQuestion: number): boolean {
    let hasValues:boolean = false;
    let valCasTotal = this.model.doc.cuerpo[questions[indexQuestion].totalField] ? this.model.doc.cuerpo[questions[indexQuestion].totalField].toString() : "0";
    if(this.model.doc.cuerpo[questions[indexQuestion].totalField] instanceof Array){//No debería pero si se usó una casilla compuesta para almacenar el total entonces evaluarlo como la suma total de los registros
      let suma= "0";
      let casArray:Array<string> = this.model.doc.cuerpo[questions[indexQuestion].totalField];
      for(let i=0; i<casArray.length; i++){
        let valItem = this.dutilidades.deshacerFormatoMoneda(this.model.doc.cuerpo[questions[indexQuestion].totalField][i].v);
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, suma, valItem);
      }
      valCasTotal = suma;
    }
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valCasTotal, "0")) {
      hasValues = true;
    }
    if(indexQuestion==1){//1 I2 ¿Fue trabajador independiente ?
      if(this.model.doc.cuerpo['cc_id_309'] && this.model.doc.cuerpo['cc_id_309'].length>0){
        hasValues = true;
      }
    }
    return hasValues;
  }

  protected cleanModalValues(indexQuestionModal: number) {
    switch (indexQuestionModal) {
      case 0:  //0 I1 ¿Fue asalariado o funcionario público?
        this.model.doc.cuerpo.cc_id_277 = [];//pagador
        this.model.doc.cuerpo.cc_id_278 = []; //origen
        this.model.doc.cuerpo.cc_id_279 = []; //valor
        this.model.doc.cuerpo.cs_id_280 = "0"; //Total 

        this.model.doc.cuerpo.cc_id_286 = []; //Ingreso Laboral Promedio
        this.model.doc.cuerpo.cc_id_284 = []; //Retención
        this.model.doc.cuerpo.cc_id_285 = []; //Cesantías
        this.model.doc.cuerpo.cc_id_288 = []; //Aporte a salud
        this.model.doc.cuerpo.cc_id_287 = []; //Aporte obligatorio pensión
        this.model.doc.cuerpo.cc_id_291 = []; //Aporte voluntario pensión
        this.model.doc.cuerpo.cc_id_290 = []; //Aportes cuentas AFC O AVC
        this.model.doc.cuerpo.cc_id_292 = []; //Apoyos económicos educativos
        this.model.doc.cuerpo.cc_id_289 = []; //Cotizaciones voluntarias – RAIS
        this.model.doc.cuerpo.cc_id_294 = []; //limitante AFC
        this.model.doc.cuerpo.cc_id_295 = []; //Limitante RAIS
        this.model.doc.cuerpo.cc_id_296 = []; //Limitante aportes voluntarios a fondo pensión
        this.model.doc.cuerpo.cc_id_297 = []; //25% exento
        this.model.doc.cuerpo.cc_id_298 = []; //Cesantías parte exenta

        break;
      case 1:  //1 I2 ¿Fue trabajador independiente ?
        //TODO Completar campos
        //Casillas compuestas
      this.model.doc.cuerpo.cc_id_309 = [];  //Casilla 309	Nombre pagador 
      this.model.doc.cuerpo.cc_id_302 = [];  //Casilla 302	Origen de la Información
      this.model.doc.cuerpo.cc_id_303 = [];  //Casilla 303	Tipo de renta 
      this.model.doc.cuerpo.cc_id_304 = [];  //Casilla 304	Valor
      this.model.doc.cuerpo.cc_id_310 = [];  //Casilla 310	Retención
      this.model.doc.cuerpo.cc_id_312 = [];  //Casilla 312	Aporte a salud
      this.model.doc.cuerpo.cc_id_313 = [];  //Casilla 313	Aporte obligatorio pensión
      this.model.doc.cuerpo.cc_id_316 = [];  //Casilla 316	Aporte ARL
      this.model.doc.cuerpo.cc_id_314 = [];  //Casilla 314	Aporte voluntario a pensión
      this.model.doc.cuerpo.cc_id_315 = [];  //Casilla 315	Aporte cuenta AFC o AVC
      this.model.doc.cuerpo.cc_id_311 = [];  //Casilla 311	Aporte a cesantía 
      this.model.doc.cuerpo.cc_id_319 = [];  //Casilla 319	Limitante AFC
      this.model.doc.cuerpo.cc_id_320 = [];  //Casilla 320	Limitante aportes voluntarios pensión
      this.model.doc.cuerpo.cc_id_321 = [];  //Casilla 321	Limitante cotización RAIS
      this.model.doc.cuerpo.cc_id_322 = [];  //Casilla 322	25% Exento
      this.model.doc.cuerpo.cc_id_307 = [];  //Casilla 307	Limitantes aporte voluntario a Cesantias 
      this.model.doc.cuerpo.cc_id_308 = [];  //Casilla 308	Perdidas
      this.model.doc.cuerpo.cc_id_317 = [];  //Casilla 317 Cotización voluntaria RAIS
      this.model.doc.cuerpo.cc_id_318 = [];  //Casilla 318 Costos y gastos

      this.model.doc.cuerpo.cs_id_305 = "0"; //Total 
      
        break;
      case 2:  //3 I3 ¿Tuvo ingresos por arrendamientos, rendimientos financieros, intereses, regalías o explotación de propiedad intelectual en Colombia o en el exterior?
        this.model.doc.cuerpo.cc_id_324 = []; //pagador
        this.model.doc.cuerpo.cc_id_326 = []; //concepto
        this.model.doc.cuerpo.cc_id_325 = []; //origen
        this.model.doc.cuerpo.cc_id_327 = []; //valor
        this.model.doc.cuerpo.cc_id_333 = []; //parte no gravada
        this.model.doc.cuerpo.cc_id_334 = []; //retencion
        this.model.doc.cuerpo.cs_id_328 = "0";
        break;
      case 3:  //4 I4 ¿Fue comerciante, ganadero, agricultor, ejerció como notario, curador urbano o tuvo otras actividades por delegación del Estado?
      this.model.doc.cuerpo.cc_id_339 = []; //informante
      this.model.doc.cuerpo.cc_id_341 = []; //actividad
      this.model.doc.cuerpo.cc_id_340 = []; //origen
      this.model.doc.cuerpo.cc_id_342 = []; //valor
      this.model.doc.cuerpo.cc_id_346 = []; //retencion
      this.model.doc.cuerpo.cc_id_347 = []; //devoluciones
      this.model.doc.cuerpo.cs_id_343 = "0";
        break;
      case 4:  //10 I5 ¿Recibió ingresos por pensión, indemnización sustitutiva de pensión o devolución de ahorro pensional?
      this.model.doc.cuerpo.cc_id_351 = []; //pagador
      this.model.doc.cuerpo.cc_id_352 = []; //origen
      this.model.doc.cuerpo.cc_id_353 = []; //tipoPension
      this.model.doc.cuerpo.cc_id_354 = []; //valor
      this.model.doc.cuerpo.cc_id_359 = []; //numMeses
      this.model.doc.cuerpo.cc_id_360 = []; //aporteSalud
      this.model.doc.cuerpo.cc_id_361 = []; //impuestoExt
      this.model.doc.cuerpo.cc_id_362 = []; //retencion
      this.model.doc.cuerpo.cc_id_363 = []; //limRentaEx
      this.model.doc.cuerpo.cs_id_355 = "0";
        break;
      case 5:  //2 I6 ¿Retiró ahorros de cuentas AFC, FVP o AVC, sin cumplir las condiciones de permanencia y destinación?
        //TODO Completar campos
      this.model.doc.cuerpo.cs_id_368 = []	//Pagador
      this.model.doc.cuerpo.cs_id_369 = []	//Origen de la información
      this.model.doc.cuerpo.cs_id_370 = []	//Tipo de renta
      this.model.doc.cuerpo.cs_id_371 = []	//Valor Item
      this.model.doc.cuerpo.cs_id_372 = '0'	//Valor Total
      
      this.model.doc.cuerpo.cs_id_364 = []	//Retención
      
        break;
      case 6:  //11 I7 ¿Tuvo ingresos por dividendos o participaciones?
        
        this.model.doc.cuerpo.cc_id_490 = []; //Pagador
        this.model.doc.cuerpo.cc_id_491 = []; //OrigenDeLaInformación
        this.model.doc.cuerpo.cc_id_492 = []; //Concepto
        this.model.doc.cuerpo.cc_id_493 = []; //valorItem
        this.model.doc.cuerpo.cs_id_494 = '0'; //valorTotal
        this.model.doc.cuerpo.cc_id_499 = []; //tarifas
        this.model.doc.cuerpo.cc_id_500 = []; //retención
        this.model.doc.cuerpo.cc_id_501 = [];
        break;
      case 7:  //5 I8 ¿Vendió el inmueble donde usted vivía? 
        this.model.doc.cuerpo.cc_id_508 = [];
        this.model.doc.cuerpo.cc_id_509 = [];
        this.model.doc.cuerpo.cs_id_509 = "0";
        this.model.doc.cuerpo.cc_id_510 = [];
        this.model.doc.cuerpo.cc_id_514 = [];
        this.model.doc.cuerpo.cc_id_515 = [];
        this.model.doc.cuerpo.cc_id_516 = [];
        this.model.doc.cuerpo.cc_id_517 = [];
        this.model.doc.cuerpo.cc_id_518 = [];
        this.model.doc.cuerpo.cc_id_519 = [];
        this.model.doc.cuerpo.cc_id_520 = [];
        this.model.doc.cuerpo.cc_id_521 = [];
        this.model.doc.cuerpo.cc_id_522 = [];
        this.model.doc.cuerpo.cc_id_523 = [];
        this.model.doc.cuerpo.cc_id_524 = [];
        this.model.doc.cuerpo.cc_id_525 = [];
        this.model.doc.cuerpo.cc_id_526 = [];
        this.model.doc.cuerpo.cc_id_527 = [];
        this.model.doc.cuerpo.cc_id_528 = [];
        break;
      case 8:  //6 I9 ¿Vendió otros activos fijos?
        
      this.model.doc.cuerpo.cc_id_546 = []; //Ubicación
      this.model.doc.cuerpo.cc_id_535 = []; //informante
      this.model.doc.cuerpo.cc_id_537 = []; //tipo de activo
      this.model.doc.cuerpo.cc_id_536 = []; //origen
      this.model.doc.cuerpo.cc_id_547 = []; //año de compra
      this.model.doc.cuerpo.cc_id_548 = []; //valor de compra
      this.model.doc.cuerpo.cc_id_549 = []; //AnioAnteriorAplicoReajusteArt73ET
      this.model.doc.cuerpo.cc_id_550 = []; //ValorDeclaradoAnioAnterior
      this.model.doc.cuerpo.cc_id_538 = []; //Valor de venta
      this.model.doc.cuerpo.cc_id_551 = []; //mejoras
      this.model.doc.cuerpo.cc_id_552 = []; //AvaluoCatastralAnioAnterior
      this.model.doc.cuerpo.cc_id_553 = []; //costo fiscal
      this.model.doc.cuerpo.cc_id_554 = []; //RetencionDivididoImpuestoExterior
      this.model.doc.cuerpo.cc_id_555 = []; //utilidad
      this.model.doc.cuerpo.cc_id_556 = []; //ResultadoArt73Masmejoras
      this.model.doc.cuerpo.cc_id_557 = []; //AvaluoCatastralMasMejoras
      this.model.doc.cuerpo.cc_id_558 = []; //ValorDeclaradoAnioAnteriorMasMejoras
      this.model.doc.cuerpo.cc_id_559 = []; //ValorDeCompraMasMejoras
      this.model.doc.cuerpo.cs_id_539 = "0"; //ValorDeCompraMasMejoras

      case 9:  //8 I10 ¿Tuvo utilidades por liquidación de alguna sociedad de la que fue socio o partícipe?
        this.model.doc.cuerpo.cc_id_565 = [];  //565	Sociedad
        this.model.doc.cuerpo.cc_id_566 = [];  //566	Utilidad
        this.model.doc.cuerpo.cc_id_569 = [];  //569	Valor aporte social
        this.model.doc.cuerpo.cc_id_574 = [];  //574	Año de constitución
        this.model.doc.cuerpo.cc_id_575 = [];  //575	Retención
        this.model.doc.cuerpo.cs_id_568 = '0'; //568	Valor Total
        
        break;
      case 10:  //12 I11 ¿Recibió ingresos por herencias, donaciones, divorcio o porción conyugal?
        this.model.doc.cuerpo.cc_id_582 = []; //informante
        this.model.doc.cuerpo.cc_id_583 = []; //origen
        this.model.doc.cuerpo.cc_id_584 = []; //concepto
        this.model.doc.cuerpo.cc_id_591 = []; //concIngGO
        this.model.doc.cuerpo.cc_id_593 = []; //porcentaje
        this.model.doc.cuerpo.cc_id_585 = []; //valor
        this.model.doc.cuerpo.cc_id_594 = []; //retencion
        this.model.doc.cuerpo.cc_id_595 = []; //Limitante 13000 UVT
        this.model.doc.cuerpo.cc_id_597 = []; //Limitante 3250 UVT 
        this.model.doc.cuerpo.cc_id_596 = []; //Limitante 6500 UVT
        this.model.doc.cuerpo.cc_id_598 = []; //Todo exento
        this.model.doc.cuerpo.cc_id_576 = []; //Limitante 1625 UVT o 20%
        this.model.doc.cuerpo.cs_id_586 = '0'; //Total

        break;
      case 11:  //13 I12 ¿Recibió ingresos por loterías, premios, rifas, apuestas o similares?

        this.model.doc.cuerpo.cc_id_605 = []; //Pagador
        this.model.doc.cuerpo.cc_id_606 = []; //OrigenDeLaInformación
        this.model.doc.cuerpo.cc_id_607 = []; //valorItem
        this.model.doc.cuerpo.cs_id_608 = '0'; //Total
        this.model.doc.cuerpo.cc_id_615 = []; //retención
        break;
        case 12:  //7 I13 621	I13	¿Tuvo ingresos por rentas pasivas de Entidades Controladas del Exterior (ECE)? 	NO	Ayuda Pregunta 13, se actualizará una vez esté revisada por el área funcional.

        this.model.doc.cuerpo.cc_id_622 = []; //622	Entidad
        this.model.doc.cuerpo.cc_id_623 = []; //623	Tipo de Renta
        this.model.doc.cuerpo.cc_id_624 = []; //624	Valor
        this.model.doc.cuerpo.cc_id_625 = []; //625	Ingreso pasivo
        this.model.doc.cuerpo.cs_id_626 = '0'; //625	Ingreso pasivo
        this.model.doc.cuerpo.cc_id_631 = []; //631	Impuesto pagado en el exterior
        break;


      case 13:  //14 I14 ¿Tuvo otros ingresos? //cs_id_713
      
        this.model.doc.cuerpo.cc_id_646=[];	//Concepto
        this.model.doc.cuerpo.cc_id_647=[];	//Valor Item
        this.model.doc.cuerpo.cs_id_648='0';	//Total
        this.model.doc.cuerpo.cc_id_649=[];	//Retención
        this.model.doc.cuerpo.cc_id_651=[];	//Pagador
        break;
      default:
        break;
    }
    this.dependenciadeTarjetas(indexQuestionModal);
    this.saveModel.emit(true);
    console.log(this.model);
  }


  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if (this.model.doc.cuerpo[data.field] == "0") {
      if (this.questionHasSugerida(index)) {
        const dialogRef = this.dialog.open(DialogoConfirmacionComponent, {
          data: {
            mensaje1: 'Usted tiene información sugerida para esta pregunta',
            mensaje2: 'Puede revisarla u omitirla para continuar con la siguiente pregunta.',
            botonTrue: 'Revisar',
            botonFalse: 'Omitir'
          }
        });
        dialogRef
          .afterClosed().subscribe(res => {

            if (res) {
              this.model.doc.cuerpo[data.field] = "1";//restaura el radio button a Sí
              this.validateModalCompleted(index);
              this.saveModel.emit(true);
              this.openModal(index);
              questions[index].resp="1";
              return;//sale sin mostrar el segundo modal que pregunta si quiere eliminar los datos
            }else{
              this.validateModalCompleted(index);
            }
            this.askIfDeleteModalData(index, data);

          });

      } else {
        this.validateModalCompleted(index);
        this.askIfDeleteModalData(index, data);
      }

    } else if (this.model.doc.cuerpo[data.field] == "1") {
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrándolo completo
      this.openModal(index);
      this.saveModel.emit(true);
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
  }

  private askIfDeleteModalData(index: number, data: any) {
    if (this.validateHasModalValues(index)) {

      const dialogRef2 = this.dialog.open(DialogoConfirmacionComponent, {
        data: {
          mensaje1: '¿Está seguro de eliminar esta información?',
          mensaje2: 'Al hacerlo no podrá recuperarla.',
          botonTrue: 'Sí',
          botonFalse: 'No'
        }
      });
      dialogRef2
        .afterClosed().subscribe(result => {
          if (result) { //si desea eliminar el contenido del modal
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          } else { //no desea eliminar el contenido del modal
            questions[index].resp="1";
            this.model.doc.cuerpo[data.field] = "1";
            this.validateModalCompleted(index);
            this.saveModel.emit(true);
          }
        });
    } else {
      questions[index].isCompleted = true;
      this.cleanModalValues(index);
      this.validateModalCompleted(index);
      this.saveModel.emit(true);
    }
  }
  dependenciadeTarjetas(indexQuestionModal: number)
  {
    
    switch (indexQuestionModal) {
      case 0:  //0 I1 ¿Fue asalariado o funcionario público?  
          this.calcular702();    
          const componentIngTrabIndependiente= this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
          componentIngTrabIndependiente.instance.UVT=this.uvt ;
          componentIngTrabIndependiente.instance.initializeTablaDesdeModelo();
          componentIngTrabIndependiente.instance.operacionTotalizarCasillasOcultas();//las dependiencias son en casillas ocultas, no en total
       
          const componentBenTribDeducciones = this._componentFactory.createModalComponent(BeneficiosTributariosDeduccionesEspecialesModalComponent, { model: this.model });
          componentBenTribDeducciones.instance.initializeTablaDesdeModelo();
          const table = componentBenTribDeducciones.instance.dataSourceBody;
          componentBenTribDeducciones.instance.uvt = this.uvt;
          if(table){
            for(let i=0; i<table.length; i++){
              componentBenTribDeducciones.instance.modelForm = table[i];
              componentBenTribDeducciones.instance.calcularLimDepen();
              componentBenTribDeducciones.instance.calcularValorItem();
              this.model.doc.cuerpo.cc_id_715[i].v = componentBenTribDeducciones.instance.modelForm.limDepen;
              this.model.doc.cuerpo.cc_id_713[i].v = componentBenTribDeducciones.instance.modelForm.valor;
              componentBenTribDeducciones.instance.inicializeForm();
            }
          }
                    
          const componentBenIngNoRenta0 = this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });

          componentBenIngNoRenta0.instance.uvt = this.uvt; //corrige uvt quemada $42412
          componentBenIngNoRenta0.instance.reset();
          componentBenIngNoRenta0.instance.initializeTablaDesdeModelo();
          componentBenIngNoRenta0.instance.operacionCS691();
          componentBenIngNoRenta0.instance.operacionCS676();
          componentBenIngNoRenta0.instance.guardar();
        
          
          this.calcular702();    
        break;
      case 1:  //1 I2 ¿Fue trabajador independiente ?
          this.calcular702();    
          const componentBeneficiosDeduccionesEsp = this._componentFactory.createModalComponent(BeneficiosTributariosDeduccionesEspecialesModalComponent, { model: this.model });
          componentBeneficiosDeduccionesEsp.instance.uvt = this.uvt;
          componentBeneficiosDeduccionesEsp.instance.actualizarDataTrabInd();
          componentBeneficiosDeduccionesEsp.instance.initializeTablaDesdeModelo();
          const table1 = componentBeneficiosDeduccionesEsp.instance.dataSourceBody;
          if(table){
            for(let i=0; i<table.length; i++){
              componentBeneficiosDeduccionesEsp.instance.modelForm = table[i];
              componentBeneficiosDeduccionesEsp.instance.calcularLimDepen();
              componentBeneficiosDeduccionesEsp.instance.calcularValorItem();
              this.model.doc.cuerpo.cc_id_715[i].v = componentBeneficiosDeduccionesEsp.instance.modelForm.limDepen;
              this.model.doc.cuerpo.cc_id_713[i].v = componentBeneficiosDeduccionesEsp.instance.modelForm.valor;
              componentBeneficiosDeduccionesEsp.instance.inicializeForm();
            }
          }

          const componentAsalariado = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
          componentAsalariado.instance.UVT = this.uvt;
          componentAsalariado.instance.initializeTablaDesdeModelo();
          componentAsalariado.instance.operacionCs280();

          
          const componentBenIngNoRenta= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });

          componentBenIngNoRenta.instance.uvt = this.uvt; //corrige uvt quemada $42412
          componentBenIngNoRenta.instance.reset();
          componentBenIngNoRenta.instance.initializeTablaDesdeModelo();
          componentBenIngNoRenta.instance.operacionCS691();
          componentBenIngNoRenta.instance.operacionCS676();
          componentBenIngNoRenta.instance.guardar();
        
        break;
      case 2:  //3 I3 ¿Tuvo ingresos por arrendamientos, rendimientos financieros, intereses, regalías o explotación de propiedad intelectual en Colombia o en el exterior?
      const componentIngAsalariadoServPub = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentIngAsalariadoServPub.instance.UVT=this.uvt;
      componentIngAsalariadoServPub.instance.initializeTablaDesdeModelo();
      componentIngAsalariadoServPub.instance.operacionesLimitantesComunes();
  
      const componentIngresosTrabInd = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngresosTrabInd.instance.UVT=this.uvt;
      componentIngresosTrabInd.instance.initializeTablaDesdeModelo();
      for(let i=0; i<this.model.doc.cuerpo.cc_id_309.length; i++){
        componentIngresosTrabInd.instance.operacionCs319(i);
        componentIngresosTrabInd.instance.operacionCs320(i);
        componentIngresosTrabInd.instance.operacionCs321(i);  
        componentIngresosTrabInd.instance.operacionCs307(i);  
      }  
  
      const componentImpRenAnticipos = this._componentFactory.createModalComponent(AnticiposComponent,  this.model );
      for(let i=0; i<this.model.doc.cuerpo.cc_id_802.length; i++){
        this.model.doc.cuerpo.cc_id_797[i].v =  componentImpRenAnticipos.instance.getCalculateRetenciones();
      } 
      
     
      const componentBenIngNoRenta2= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
      componentBenIngNoRenta2.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta2.instance.reset();
      componentBenIngNoRenta2.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta2.instance.operacionCS691();
      componentBenIngNoRenta2.instance.operacionCS676();
      componentBenIngNoRenta2.instance.guardar();
     
      const componentBenTribDeducciones2 = this._componentFactory.createModalComponent(BeneficiosTributariosDeduccionesEspecialesModalComponent, { model: this.model });
      componentBenTribDeducciones2.instance.initializeTablaDesdeModelo();
      const table2 = componentBenTribDeducciones2.instance.dataSourceBody;
      if(table)
        for(let i=0; i<table2.length; i++){
          componentBenTribDeducciones2.instance.modelForm = table2[i];
          componentBenTribDeducciones2.instance.calcularValorItem();
          this.model.doc.cuerpo.cc_id_713[i].v = componentBenTribDeducciones2.instance.modelForm.valor;
          componentBenTribDeducciones2.instance.inicializeForm();
        }
      
        break;
      case 3:  //4 I4 ¿Fue comerciante, ganadero, agricultor, ejerció como notario, curador urbano o tuvo otras actividades por delegación del Estado?
      const componentIngAsalariadoServPub3 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentIngAsalariadoServPub3.instance.UVT=this.uvt;
      componentIngAsalariadoServPub3.instance.initializeTablaDesdeModelo();
      componentIngAsalariadoServPub3.instance.operacionesLimitantesComunes();
  
      const componentIngresosTrabInd3 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngresosTrabInd3.instance.UVT=this.uvt;

      componentIngresosTrabInd3.instance.initializeTablaDesdeModelo();
      for(let i=0; i<this.model.doc.cuerpo.cc_id_309.length; i++){
        componentIngresosTrabInd3.instance.operacionCs319(i);
        componentIngresosTrabInd3.instance.operacionCs320(i);
        componentIngresosTrabInd3.instance.operacionCs321(i);
        componentIngresosTrabInd3.instance.operacionCs307(i);
      } 
  
      const componentImpRenAnticipos3 = this._componentFactory.createModalComponent(AnticiposComponent,  this.model );
      for(let i=0; i<this.model.doc.cuerpo.cc_id_802.length; i++){
        this.model.doc.cuerpo.cc_id_797[i].v =  componentImpRenAnticipos3.instance.getCalculateRetenciones();
      } 
      
      const componentBenIngNoRenta3= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
      componentBenIngNoRenta3.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta3.instance.reset();
      componentBenIngNoRenta3.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta3.instance.operacionCS691();
      componentBenIngNoRenta3.instance.operacionCS676();
      componentBenIngNoRenta3.instance.guardar();
      
      const componentBenTribDeducciones3 = this._componentFactory.createModalComponent(BeneficiosTributariosDeduccionesEspecialesModalComponent, { model: this.model });
      componentBenTribDeducciones3.instance.initializeTablaDesdeModelo();
      const table3 = componentBenTribDeducciones3.instance.dataSourceBody;
      if(table3)
        for(let i=0; i<table3.length; i++){
          componentBenTribDeducciones3.instance.modelForm = table3[i];
          componentBenTribDeducciones3.instance.calcularValorItem();
          this.model.doc.cuerpo.cc_id_713[i].v = componentBenTribDeducciones3.instance.modelForm.valor;
          componentBenTribDeducciones3.instance.inicializeForm();
        }
      break;
      case 4:  //10 I5 ¿Recibió ingresos por pensión, indemnización sustitutiva de pensión o devolución de ahorro pensional?
      this.calcular702();
      const componentBeneficiosDescuentos4 = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent,   this.model );
      componentBeneficiosDescuentos4.instance.inicializeModelo();
      componentBeneficiosDescuentos4.instance.actualizarDataPen();
  
      const componentImpRenAnticipos4 = this._componentFactory.createModalComponent(AnticiposComponent,  this.model );
      componentImpRenAnticipos4.instance.startProcess();
        
      const componentBenIngNoRenta4= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
      componentBenIngNoRenta4.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta4.instance.reset();
      componentBenIngNoRenta4.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta4.instance.operacionCS691();
      componentBenIngNoRenta4.instance.operacionCS676();
      componentBenIngNoRenta4.instance.guardar();
        break;
      case 5:  //2 I6 ¿Retiró ahorros de cuentas AFC, FVP o AVC, sin cumplir las condiciones de permanencia y destinación?

      const componentIngAsalariadoServPub1 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentIngAsalariadoServPub1.instance.UVT=this.uvt;
      componentIngAsalariadoServPub1.instance.initializeTablaDesdeModelo();
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cc_id_279.length.toString(), '0') || this.model.doc.cuerpo.cc_id_279 == undefined)
      {
        componentIngAsalariadoServPub1.instance.inicializeForm();
      }
      componentIngAsalariadoServPub1.instance.operacionesLimitantesComunes();
      componentIngAsalariadoServPub1.instance.operacionCs280();
     // componentIngAsalariadoServPub.instance.operacionCc297();
  
      const componentIngTrabIndependiente1 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngTrabIndependiente1.instance.UVT=this.uvt;

      componentIngTrabIndependiente1.instance.initializeTablaDesdeModelo();
      componentIngTrabIndependiente1.instance.operacionCs305();
  
  
  
      const componentBenIngNoRenta1= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
  
      componentBenIngNoRenta1.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta1.instance.reset();
      componentBenIngNoRenta1.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta1.instance.operacionCS691();
      componentBenIngNoRenta1.instance.operacionCS676();
      componentBenIngNoRenta1.instance.guardar();
  
      const componentIngComerciante = this._componentFactory.createModalComponent(IngresosComercianteModalComponent, { model: this.model });
      componentIngComerciante.instance.initializeTablaDesdeModelo();
      componentIngComerciante.instance.operacionCs343();
  
      const componentIngresosArrend = this._componentFactory.createModalComponent(IngresosArrendamientosModalComponent, { model: this.model });
      componentIngresosArrend.instance.initializeTablaDesdeModelo();
      componentIngresosArrend.instance.operacionCs328();
  
        break;

      case 6:  //11 I7 ¿Tuvo ingresos por dividendos o participaciones?
      
    const componentBeneficiosDescuentos = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent,   this.model );
    componentBeneficiosDescuentos.instance.inicializeModelo();
    componentBeneficiosDescuentos.instance.actualizarDataDivi();

    const componentIngAsalariadoServPub6 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
    componentIngAsalariadoServPub6.instance.UVT=this.uvt;
    componentIngAsalariadoServPub6.instance.initializeTablaDesdeModelo();
    componentIngAsalariadoServPub6.instance.operacionesLimitantesComunes();

    
    const componentIngresosTrabInd6 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
    componentIngresosTrabInd6.instance.UVT=this.uvt;

    componentIngresosTrabInd6.instance.initializeTablaDesdeModelo();
    for(let i=0; i<this.model.doc.cuerpo.cc_id_309.length; i++){
      componentIngresosTrabInd6.instance.operacionCs319(i);
      componentIngresosTrabInd6.instance.operacionCs320(i);
      componentIngresosTrabInd6.instance.operacionCs321(i);
      componentIngresosTrabInd6.instance.operacionCs307(i);
    } 


   
    const componentBenIngNoRenta6= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });

    componentBenIngNoRenta6.instance.uvt = this.uvt; //corrige uvt quemada $42412
    componentBenIngNoRenta6.instance.reset();
    componentBenIngNoRenta6.instance.initializeTablaDesdeModelo();
    componentBenIngNoRenta6.instance.operacionCS691();
    componentBenIngNoRenta6.instance.operacionCS676();
    componentBenIngNoRenta6.instance.guardar();
        break;
      case 7:  //5 I8 ¿Vendió el inmueble donde usted vivía? 
      const componentBeneficiosDescuentos7 = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent, this.model);
      componentBeneficiosDescuentos7.instance.inicializeModelo();
      componentBeneficiosDescuentos7.instance.actualizarDataVenVivi();
  
      const componentIngAsalariadoServPub7 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentIngAsalariadoServPub7.instance.UVT=this.uvt;
      componentIngAsalariadoServPub7.instance.initializeTablaDesdeModelo();
      componentIngAsalariadoServPub7.instance.operacionesLimitantesComunes();
  
  
      const componentIngresosTrabInd7 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngresosTrabInd7.instance.UVT=this.uvt;


      componentIngresosTrabInd7.instance.initializeTablaDesdeModelo();
      for (let i = 0; i < this.model.doc.cuerpo.cc_id_309.length; i++) {
        componentIngresosTrabInd7.instance.operacionCs319(i);
        componentIngresosTrabInd7.instance.operacionCs320(i);
        componentIngresosTrabInd7.instance.operacionCs321(i);
        componentIngresosTrabInd7.instance.operacionCs307(i);
      }
  
  
  
      const componentBenIngNoRenta7 = this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
  
      componentBenIngNoRenta7.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta7.instance.reset();
      componentBenIngNoRenta7.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta7.instance.operacionCS691();
      componentBenIngNoRenta7.instance.operacionCS676();
      componentBenIngNoRenta7.instance.guardar();
  
      console.log(this.model.doc.cuerpo.cs_id_691)
      const componentIngTrabIndependiente7 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngTrabIndependiente7.instance.UVT=this.uvt;

      componentIngTrabIndependiente7.instance.initializeTablaDesdeModelo();
      componentIngTrabIndependiente7.instance.operacionTotalizarCasillasOcultas();//las dependiencias son en casillas ocultas, no en total
  
  
      const componentAsalariado7 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentAsalariado7.instance.UVT = this.uvt; //corrige uvt quemada $42412
      componentAsalariado7.instance.initializeTablaDesdeModelo();
      componentAsalariado7.instance.operacionCs280();
  
        break;
      case 8:  //6 I9 ¿Vendió otros activos fijos?
      const componentIngresosComerciante8 = this._componentFactory.createModalComponent(IngresosComercianteModalComponent, this);
    componentIngresosComerciante8.instance.inicializeModelo();
    componentIngresosComerciante8.instance.operacionCs343();

    const componentBeneficiosDescuentos8 = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent, this.model);
    componentBeneficiosDescuentos8.instance.inicializeModelo();
    componentBeneficiosDescuentos8.instance.actualizarDataActiFijo();

    const componentAsalariado8 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
    componentAsalariado8.instance.UVT = this.uvt; //corrige uvt quemada $42412
    componentAsalariado8.instance.initializeTablaDesdeModelo();
    componentAsalariado8.instance.operacionCs280();

    const componentIngTrabIndependiente8 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
    componentIngTrabIndependiente8.instance.UVT=this.uvt;
 
    componentIngTrabIndependiente8.instance.initializeTablaDesdeModelo();
    componentIngTrabIndependiente8.instance.operacionTotalizarCasillasOcultas();//las dependiencias son en casillas ocultas, no en total


    const componentBenIngNoRenta8= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });

    componentBenIngNoRenta8.instance.uvt = this.uvt; //corrige uvt quemada $42412
    componentBenIngNoRenta8.instance.reset();
    componentBenIngNoRenta8.instance.initializeTablaDesdeModelo();
    componentBenIngNoRenta8.instance.operacionCS691();
    componentBenIngNoRenta8.instance.operacionCS676();
    componentBenIngNoRenta8.instance.guardar();
        break;
      case 9:  //8 I10 ¿Tuvo utilidades por liquidación de alguna sociedad de la que fue socio o partícipe?
      const componentIngAsalariadoServPub9 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentIngAsalariadoServPub9.instance.UVT=this.uvt;
      componentIngAsalariadoServPub9.instance.initializeTablaDesdeModelo();
      componentIngAsalariadoServPub9.instance.operacionesLimitantesComunes();
  
      const componentIngresosTrabInd9 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngresosTrabInd9.instance.UVT=this.uvt;

      componentIngresosTrabInd9.instance.initializeTablaDesdeModelo();
      for(let i=0; i<this.model.doc.cuerpo.cc_id_309.length; i++){
        componentIngresosTrabInd9.instance.operacionCs319(i);
        componentIngresosTrabInd9.instance.operacionCs320(i);
        componentIngresosTrabInd9.instance.operacionCs321(i);
        componentIngresosTrabInd9.instance.operacionCs307(i);
      } 
  
      const componentImpRenAnticipos9 = this._componentFactory.createModalComponent(AnticiposComponent,  this.model );
      for(let i=0; i<this.model.doc.cuerpo.cc_id_802.length; i++){
        this.model.doc.cuerpo.cc_id_797[i].v =  componentImpRenAnticipos9.instance.getCalculateRetenciones();
      }  
  
      const componentBenIngNoRenta9= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
      componentBenIngNoRenta9.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta9.instance.reset();
      componentBenIngNoRenta9.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta9.instance.operacionCS691();
      componentBenIngNoRenta9.instance.operacionCS676();
      componentBenIngNoRenta9.instance.guardar();
        break;
      case 10:  //12 I11 ¿Recibió ingresos por herencias, donaciones, divorcio o porción conyugal?
        
        const componentIngAsalariadoServPub10 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
        componentIngAsalariadoServPub10.instance.UVT=this.uvt;
        componentIngAsalariadoServPub10.instance.initializeTablaDesdeModelo();
        componentIngAsalariadoServPub10.instance.operacionesLimitantesComunes();
    
        const componentIngTrabIndependiente10= this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
        componentIngTrabIndependiente10.instance.UVT=this.uvt;
        
        componentIngTrabIndependiente10.instance.initializeTablaDesdeModelo();
        componentIngTrabIndependiente10.instance.operacionCs305();
        
        const componentBenIngNoRenta10= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
    
        componentBenIngNoRenta10.instance.uvt = this.uvt; //corrige uvt quemada $42412
        componentBenIngNoRenta10.instance.reset();
        componentBenIngNoRenta10.instance.initializeTablaDesdeModelo();
        componentBenIngNoRenta10.instance.operacionCS691();
        componentBenIngNoRenta10.instance.operacionCS676();
        componentBenIngNoRenta10.instance.guardar();
        break;
      case 11:  //13 I12 ¿Recibió ingresos por loterías, premios, rifas, apuestas o similares?
      const componentAsalariado11 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentAsalariado11.instance.UVT = this.uvt; //corrige uvt quemada $42412
      componentAsalariado11.instance.initializeTablaDesdeModelo();
      componentAsalariado11.instance.operacionCs280();
 
         const componentIngTrabIndependiente11= this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngTrabIndependiente11.instance.UVT=this.uvt;

      componentIngTrabIndependiente11.instance.initializeTablaDesdeModelo();
      componentIngTrabIndependiente11.instance.operacionTotalizarCasillasOcultas();//las dependiencias son en casillas ocultas, no en total
   
     
    
      const componentBenIngNoRenta11= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
 
      componentBenIngNoRenta11.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta11.instance.reset();
      componentBenIngNoRenta11.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta11.instance.operacionCS691();
      componentBenIngNoRenta11.instance.operacionCS676();
      componentBenIngNoRenta11.instance.guardar();
      break;
      case 12:  //7 I13 621	I13	¿Tuvo ingresos por rentas pasivas de Entidades Controladas del Exterior (ECE)? 	NO	Ayuda Pregunta 13, se actualizará una vez esté revisada por el área funcional.
      const componentBenIngNoRenta12= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });
      componentBenIngNoRenta12.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta12.instance.reset();
      componentBenIngNoRenta12.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta12.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta12.instance.operacionCS691();
      componentBenIngNoRenta12.instance.operacionCS676();

      const componentBeneficiosDescuentos12 = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent,   this.model );
      componentBeneficiosDescuentos12.instance.actualizarDataRentPasi();
        break;
      case 13:  //14 I14 ¿Tuvo otros ingresos?

      
      const componentIngAsalariadoServPub13 = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
      componentIngAsalariadoServPub13.instance.UVT=this.uvt;
      componentIngAsalariadoServPub13.instance.initializeTablaDesdeModelo();
      componentIngAsalariadoServPub13.instance.operacionesLimitantesComunes();

    
      const componentIngresosTrabInd13 = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
      componentIngresosTrabInd13.instance.UVT=this.uvt;

      componentIngresosTrabInd13.instance.initializeTablaDesdeModelo();
      for(let i=0; i<this.model.doc.cuerpo.cc_id_309.length; i++){
        componentIngresosTrabInd13.instance.operacionCs319(i);
        componentIngresosTrabInd13.instance.operacionCs320(i);
        componentIngresosTrabInd13.instance.operacionCs321(i);
        componentIngresosTrabInd13.instance.operacionCs307(i);
      } 

      const componentIngComerciante13 = this._componentFactory.createModalComponent(IngresosComercianteModalComponent, { model: this.model });
      componentIngComerciante13.instance.initializeTablaDesdeModelo();
      componentIngComerciante13.instance.operacionCs343();
      

      const componentBenIngNoRenta13= this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });

      componentBenIngNoRenta13.instance.uvt = this.uvt; //corrige uvt quemada $42412
      componentBenIngNoRenta13.instance.reset();
      componentBenIngNoRenta13.instance.initializeTablaDesdeModelo();
      componentBenIngNoRenta13.instance.operacionCS691();
      componentBenIngNoRenta13.instance.operacionCS676();
      componentBenIngNoRenta13.instance.guardar();
        break;
    }
  }

}





// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/mis-ingresos/mis-ingresos.component.ts